import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";

// User Guide Tour "steps"
export const useGuideSteps = ( page, context ) => {
   
    const stepsAccounts = [
        {
            target: "#UG_accountAddEntity",
            content: context.t("This functionality is to create a new Customer Entity (only available for ROOT administrators)"),
            disableBeacon: true,
        },
        {
            target: "#accountsTable_filter",
            content: context.t("Enter any text to filter and find and specific account"),
            disableBeacon: true,
        },
        {
            target: "#UG_accountName",
            content: context.t('Name of Customer Account'),
        },
        {
            target: "#UG_accountDetails",
            content: context.t('Contact details and customer information'),
        },
        {
            target: "#UG_accountView",
            content: context.t('Access to view and operate the Customer Account'),
        },
        {
            target: "#UG_accountEdit",
            content: context.t('Access to view and edit the Customer Account'),
        },
        {
            target: "#UG_accountDelete",
            content: context.t('Remove Customer Account'),
        },
    ];

    const stepsAplication = [
        {
            target: "#UG_stackActionButtons",
            content: context.t("Action button to operate RESTEngine service"),
            disableBeacon: true,
        },
        {
            target: "#UG_stackActionPlay",
            content: context.t("Create the virtual infrastructure, start the full RESTEngine service, and publish your secure RESTful API"),
            disableBeacon: true,
        },
        {
            target: "#UG_stackActionReload",
            content: context.t("It executes a reread of the Business database metadata in order to detect and regenerate changes to publish in its RESTfull API"),
            disableBeacon: true,
        },
        {
            target: "#UG_stackActionRestart",
            content: context.t("Restart the RESTEngine service (executes the shutdown and startup of the service without rereading the metadata from the database)"),
            disableBeacon: true,
        },
        {
            target: "#UG_stackActionStop",
            content: context.t("Shuts down the RESTEngine service without removing the virtual infrastructure"),
            disableBeacon: true,
        },
        {
            target: "#UG_stackActionDestroy",
            content: context.t("Drop the RESTful API and remove all virtual infrastructure"),
            disableBeacon: true,
        },
        {
            target: "#UG_token",
            content: context.t("Button to get the access token. It will make it easy for you to use the services through Swagger's user interface"),
        },
        {
            target: "#UG_swagger",
            content: context.t("Button to get all your API documentation through the Swagger UI"),
        },
        {
            target: "#UG_postman",
            content: context.t("Button to download the entire RESTengine API definition and import it into the Postman application"),
        },
        {
            target: "#UG_entitiesTable",
            content: context.t('List of available Business entities on which the RESTful API was created'),
        },
        {
            target: "#UG_entityName",
            content: context.t('Business Entity Name'),
        },
        {
            target: "#entitiesListTable_filter",
            content: context.t("Enter any text to filter and find a specific Business entity"),
            disableBeacon: true,
        },
        {
            target: "#UG_entityBasicDetail",
            content: context.t('Basic detail of the Business Entity'),
        },
        {
            target: "#UG_entityFullDetail",
            content: context.t('Complete detail of the Business Entity'),
        },
        {
            target: "#UG_entitySwagger",
            content: context.t('Access to the specific URIs of the selected Business Entity through the Swagger user interface'),
        },
    ];

    
    switch (page) {
        case "Accounts":
            return {stepsValues: stepsAccounts};    
        case "Application":
            return {stepsValues: stepsAplication};    
        default:
            return;
    }
    
}
